import { editorContentTimeoffViewState } from "../..";
import { Moment } from "moment";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateSelectedTimeMapTimeoff", function updateSelectedTimeMapTimeoff(id: string, selectedTime: Moment) {
    if (editorContentTimeoffViewState() && editorContentTimeoffViewState().selectedTimeMap) {
        editorContentTimeoffViewState().selectedTimeMap.set(id, selectedTime);
    }
});